/* eslint-disable max-lines */
import React, { useState } from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import logo from 'assets/images/logo/logo.png';
import { HashLink as Link } from 'react-router-hash-link';
import DatePicker from 'react-date-picker';
import { BackImage } from 'C4';

function BookingForm(props) {
  const {
    bookingDate,
    arrivalDate,
    departureDate,
    submitForm,
    handleChange,
    numberOfGuests,
    firstName,
    lastName,
    accommodation,
    wholesaler,
    reservationNumber,
    numberOfRooms,
    totalCost,
    agentEmail,
    agentFirstName,
    agentLastName,
    handleChange1,
    handleChange2,
    handleChange3,
  } = props;

  const req = ' *';

  const params = new URLSearchParams(window.location.search);
  let mobile = true
  if (params.get('mobile')) {
    mobile = true;
  }
  
  return (
    <div className="contentContainer BookingForm">
      <BackImage />
      <div className="header">
        <Link to="/main">
          <img src={logo} alt="Logo" className="logo" />
        </Link>
        <h1>{i18n.translate('rewards.bookingForm.title')}</h1>
      </div>
      <hr />
      <div className="body">
        <form method="post" id="formRewards">
          <h3>{i18n.translate('rewards.bookingForm.subTitle')}</h3>

          <div className="grid">
            <div className="item medium">
              <label htmlFor="agentEmail">
                {i18n.translate('rewards.bookingForm.email').concat(req)}
                <input
                  type="email"
                  name="agentEmail"
                  value={agentEmail}
                  onChange={handleChange}
                  placeholder="Agent email"
                  required
                />
              </label>
            </div>
            <div className="item medium">
              <label htmlFor="agentFirstName">
                {i18n.translate('rewards.bookingForm.agentFirstName').concat(req)}
                <input
                  name="agentFirstName"
                  value={agentFirstName}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.agentFirstName')}
                  required
                />
              </label>
            </div>
            <div className="item medium">
              <label htmlFor="agentLastName">{i18n.translate('rewards.bookingForm.agentLastName').concat(req)}</label>
              <input
                name="agentLastName"
                value={agentLastName}
                onChange={handleChange}
                placeholder={i18n.translate('rewards.bookingForm.agentLastName')}
                required
              />
            </div>
          </div>
          <hr />
          <div className="grid">

            <div className="item medium">
              <label htmlFor="reservationNumber">
                {i18n.translate('rewards.bookingForm.reservationNumber').concat(req)}
                <input
                  name="reservationNumber"
                  value={reservationNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.reservationNumber')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="firstName">
                {i18n.translate('rewards.bookingForm.firstName').concat(req)}
                <input
                  name="firstName"
                  value={firstName}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.firstName')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="lastName">
                {i18n.translate('rewards.bookingForm.lastName').concat(req)}
                <input
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.lastName')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="bookingDate">
                {i18n.translate('rewards.bookingForm.bookingDate').concat(req)}
                <DatePicker
                  name="bookingDate"
                  className="DatePicker"
                  onChange={handleChange1}
                  value={bookingDate}
                  dateFormat="Pp"
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="arrivalDate">
                {i18n.translate('rewards.bookingForm.arrivalDate').concat(req)}
                <DatePicker
                  name="arrivalDate"
                  className="DatePicker"
                  onChange={handleChange2}
                  value={arrivalDate}
                  dateFormat="Pp"
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="departureDate">
                {i18n.translate('rewards.bookingForm.departureDate').concat(req)}
                <DatePicker
                  name="departureDate"
                  className="DatePicker"
                  onChange={handleChange3}
                  value={departureDate}
                  dateFormat="Pp"
                  required
                />
              </label>
            </div>

            <div className="item large">
              <label htmlFor="numberOfRooms">{i18n.translate('rewards.bookingForm.rooms').concat(req)}</label>
              <select name="numberOfRooms" value={numberOfRooms} onChange={handleChange}>
                <option>Please select an option</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="10+">10+</option>
              </select>
            </div>

            <div className="item large">
              <label htmlFor="numberOfGuests">{i18n.translate('rewards.bookingForm.numberOfGuests').concat(req)}</label>
              <select name="numberOfGuests" value={numberOfGuests} onChange={handleChange}>
                <option>Please select an option</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="10+">10+</option>
              </select>
            </div>

            <div className="item large">
              <label htmlFor="wholesaler">{i18n.translate('rewards.bookingForm.wholesaler')}</label>
              <input
                name="wholesaler"
                value={wholesaler}
                onChange={handleChange}
                placeholder={i18n.translate('rewards.bookingForm.wholesaler')}
                required
              />
            </div>

            <div className="item large">
              <label htmlFor="accommodation">{i18n.translate('rewards.bookingForm.accommodation').concat(req)}</label>
              <input
                name="accommodation"
                value={accommodation}
                onChange={handleChange}
                placeholder={i18n.translate('rewards.bookingForm.accommodation')}
                required
              />
            </div>
            <div className="item large empty" />
            <div className="item large">
              <label htmlFor="totalCost">{i18n.translate('rewards.bookingForm.cost').concat(req)}</label>
              <input
                name="totalCost"
                value={totalCost}
                onChange={handleChange}
                placeholder={i18n.translate('rewards.bookingForm.cost')}
                required
                type="number"
              />
            </div>
          </div>
          <p className="disclaimer">{i18n.translate('rewards.bookingForm.disclaimer')}</p>
          <hr />
          <button type="submit" className="btn" onClick={submitForm}>
            {i18n.translate('rewards.bookingForm.button')}
          </button>
        </form>
      </div>
    </div>
  );
}

BookingForm.propTypes = {
  submitForm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChange1: PropTypes.func.isRequired,
  handleChange2: PropTypes.func.isRequired,
  handleChange3: PropTypes.func.isRequired,
  numberOfGuests: PropTypes.string.isRequired,
  arrivalDate: PropTypes.string.isRequired,
  bookingDate: PropTypes.string.isRequired,
  departureDate: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  accommodation: PropTypes.string.isRequired,
  wholesaler: PropTypes.string.isRequired,
  reservationNumber: PropTypes.string.isRequired,
  numberOfRooms: PropTypes.string.isRequired,
  totalCost: PropTypes.string.isRequired,
  agentEmail: PropTypes.string.isRequired,
  agentFirstName: PropTypes.string.isRequired,
  agentLastName: PropTypes.string.isRequired,
};

export default BookingForm;
